import React from 'react';
import styled from 'styled-components';
import { colours } from '../Styles';
import {Link} from 'react-router-dom';

function PackageBtns() {
    const { light, accent } = colours;
    const PackageBtns = styled.div`
        button {
            margin: 5px;
            height: 40px;
            width: 100px;
            font-family: play;
            font-size: 16px;
            border-radius: 5px;
            cursor: pointer;
        }
    `;
    const BookBtn = styled.button`
    border: 3px solid ${accent};
    color: ${light};
    background: ${accent};
    :hover {
        border: 3px solid ${accent};
        background: transparent;
        color: ${accent};
    }`
    const CompareBtn = styled.button`
    border: 3px solid ${accent};
    color: ${accent};
    background: transparent;
    :hover {
        border: 3px solid transparent;
        background: ${accent};
        color: ${light};
    }`;
    return (
        <PackageBtns>
            <Link to='/book'>
                <BookBtn>Book</BookBtn>
            </Link>
            <Link to='/services'>
                <CompareBtn>Compare</CompareBtn>
            </Link>
        </PackageBtns>
    )
}

export default PackageBtns;